import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PurchaseOrderService } from '../../globals-services/purchase-order.service';

import { OrderStatusEnum } from '../../globals-enums/order.status.enum';
import { UpdatePoItemDeliveryDialogComponent } from '../update-po-item-delivery-dialog/update-po-item-delivery-dialog.component';
import { ConfirmClosePoDialogComponent } from '../confirm-close-po-dialog/confirm-close-po-dialog.component';
import { POItemUnitEnum } from '../../globals-enums/po.unit.enum';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from 'app/common/toast-alert/toast.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-view-detail-purchase-order',
    templateUrl: './view-detail-purchase-order.component.html',
    styleUrls: ['./view-detail-purchase-order.component.css'],
})
export class ViewDetailPurchaseOrderComponent implements OnInit {
    poId: any;
    poDetails: any;
    deliveries: any = [];
    displayedColumns: string[] = [
        'name',
        'quantity',
        'receivedQuantity',
        'unit',
        'status',
        'action',
    ];
    displayedAddToInvColumns: string[] = [
        'name',
        'receivedQuantity',
        'unit',
        'batchNumber',
        'date',
    ];
    OrderStatusEnum = OrderStatusEnum;
    poItems: any;
    // showSuccessChange: boolean = false;
    // showErrorChange: boolean = false;
   // closPoSuccessMessage: boolean = false;

    isLoading: boolean;
    pOUnitEnum = POItemUnitEnum;

    alertMsgs = {};

    constructor(
        private purchaseOrderService: PurchaseOrderService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private dialog: MatDialog,
        private translateService: TranslateService,
        private toastService: ToastService
    ) {}

    ngOnInit() {
        this.fetchTranslations();
        this.translateService.onLangChange.subscribe(() => {
            this.fetchTranslations();
        });

        this.activatedRoute.params.subscribe((params) => {
            this.poId = params['id'];
            this.isLoading = true;
            setTimeout(() => {
                this.isLoading = false;
            }, 3000);
            if (this.poId != null) {
                this.getPoDetails();
            }
        });
    }

    fetchTranslations() {
        this.translateService
            .get('PURCHASE_ORDER_MODULE.PO_COMPONENT.SHOW_MESSAGES')
            .subscribe((response) => {
                this.alertMsgs = response;
                // console.log(this.alertMsgs);
            });
    }

    getPoDetails() {
        let data = {
            id: this.poId,
        };

        this.purchaseOrderService.getPoDetails(data).subscribe(
            (response: any) => {
                this.poDetails = response;
                if (this.poDetails != null) {
                    this.getPoItems();
                }
            },
            (error) => {
                // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '400') {
                //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")
                // }
            }
        );
    }

    onDeliveryTabChanged(event) {
        let index = event.index;

        switch (index) {
            case 0:
                this.getPoItems();
                break;
            case 1:
                this.getDeliveries();
        }
    }
    getPoItems() {
        let data = {
            id: this.poId,
        };
        this.purchaseOrderService.getPoItems(data).subscribe(
            (response: any) => {
                this.poItems = response;
            },
            (error) => {
                // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '400') {
                //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")
                // }
            }
        );
    }
    getDeliveries() {
        let data = {
            purchaseOrderChemicalId: this.poId,
            addToInventory: false,
        };
        this.purchaseOrderService.fetchDeliveries(data).subscribe(
            (response: any) => {
                this.deliveries = response;
            },
            (error) => {
                // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '400') {
                //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")
                // }
            }
        );
    }
    backToPo() {
        this.router.navigateByUrl('/purchase-order');
    }
    AddDeliveryDialog(po, poItem) {
        const dialogRef = this.dialog.open(
            UpdatePoItemDeliveryDialogComponent,
            {
                width: '80%',
                height: '80%',
                data: {
                    po,
                    poItem,
                },
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.getPoDetails();
            }
        });
    }
    addItemToInventoryDialog(po, deliveriesItems) {
        console.info(deliveriesItems);
        let data = {
            id: po.id,
            poNumber: po.poNumber,
            manufacturerName: po.manufacturerName,
            poDate: po.poDate,
            deliveries: deliveriesItems,
        };
        this.isLoading = true;
        this.purchaseOrderService.updatePODelivery(data).subscribe(
            (response: any) => {
                if (response) {
                    this.isLoading = false;
                    this.toastService.success(
                        this.alertMsgs['PO_INVENTORY_UPDATE'],true
                    );
                    this.getDeliveries();
                    this.getPoDetails();

                    //     this.showSuccessChange = true;
                    //   this.getDeliveries()
                    //   this.getPoDetails();
                    //   setTimeout(
                    //     () => {
                    //       this.showSuccessChange = false;
                    //       this.isLoading = false
                    //     }, 3000
                    //   );
                }
            },
            (error) => {
                // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '400') {
                //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")

                // }
                this.isLoading = false;
                this.toastService.error(this.alertMsgs['PO_INVENTORY_ERROR'])
                // setTimeout(() => {
                //     this.showErrorChange = false;
                //     this.isLoading = false;
                // }, 3000);
            }
        );
    }

    openConfirmClosePODialog(po) {
        const dialogRef = this.dialog.open(ConfirmClosePoDialogComponent, {
            width: '50%',
            height: '50%',
            data: {
                referenceNumber: po.referenceNumber,
                title: 'Are you sure to close  the order?',
                pendingInventory: po.pendingInventory,
            },
        });

        dialogRef.afterClosed().subscribe((response) => {
            if (response) {
              //  console.info(response);
                po.referenceNumber = response.referenceNumber;
                this.closeOrder(po);
            }
        });
    }
    closeOrder(po) {
        this.purchaseOrderService.closeOrder(po).subscribe(
            (response: any) => {

              //  this.closPoSuccessMessage = true;
                this.isLoading = false;
                this.toastService.success(this.alertMsgs['PO_INVENTORY_SUCCESS'],true)
                this.router.navigateByUrl('/purchase-order');

                // setTimeout(() => {
                //     this.closPoSuccessMessage = false;
                //     this.isLoading = false;
                //     this.router.navigateByUrl('/purchase-order');
                // }, 3000);
            },
            (error) => {
                // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '400') {
                //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")

                // }
                setTimeout(() => {
                    this.isLoading = false;
                }, 3000);
            }
        );
    }
}
